<ng-container *ngIf="state$ | async; let state">
    <form class="mod mod-form">
        <!-- Main form components -->
        <div class="zas-row">
            <zbd-input
                type="text"
                name="FirstName"
                label="Vorname"
                class="zas-main-col"
                [entity]="state.hint"
                property="FirstName"
                [updateFn]="updateHint"
            ></zbd-input>
            <zbd-input
                type="text"
                name="LastName"
                label="Nachname / Firmenname"
                class="zas-main-col"
                [entity]="state.hint"
                property="LastName"
                [updateFn]="updateHint"
            ></zbd-input>
        </div>

        <div class="zas-row">
            <zbd-input
                type="text"
                name="EMail"
                label="E-Mail"
                class="zas-main-col"
                [entity]="state.hint"
                property="EMail"
                [updateFn]="updateHint"
            ></zbd-input>
            <zbd-input
                type="text"
                name="OfferExternalId"
                label="Angebots-Nr. / Antrags-Nr."
                class="zas-main-col"
                [entity]="state.hint"
                property="OfferExternalId"
                [updateFn]="updateHint"
            ></zbd-input>
        </div>

        <!-- Advanced form components -->
        <div *ngIf="state.extended">
            <div class="zas-row">
                <zbd-input
                    type="select"
                    name="Country"
                    label="Land"
                    class="zas-main-col"
                    [entity]="state.hint"
                    property="Country"
                    [updateFn]="updateHint"
                >
                    <option value="">alle</option>
                    <option
                        *ngFor="let country of countryList"
                        [value]="country.Data"
                    >
                        {{ country.Readable }}
                    </option>
                </zbd-input>
                <div class="zas-main-col">
                    <div class="zas-inner-table">
                        <zbd-input
                            type="text"
                            name="Zip"
                            label="PLZ"
                            class="col-xs-4 zas-inner-col-left"
                            [entity]="state.hint"
                            property="Zip"
                            [updateFn]="updateHint"
                        ></zbd-input>
                        <zbd-input
                            type="text"
                            name="City"
                            label="Ort"
                            class="col-xs-8 zas-inner-col-right"
                            [entity]="state.hint"
                            property="City"
                            [updateFn]="updateHint"
                        ></zbd-input>
                    </div>
                </div>
            </div>

            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="Street"
                    label="Strasse, Hausnummer"
                    class="zas-main-col"
                    [entity]="state.hint"
                    property="Street"
                    [updateFn]="updateHint"
                ></zbd-input>
                <zbd-input
                    type="text"
                    name="AgencyNumber"
                    label="Agenturnummer"
                    class="zas-main-col"
                    [entity]="state.hint"
                    property="AgencyNumber"
                    [updateFn]="updateHint"
                ></zbd-input>
            </div>

            <div class="zas-row">
                <zbd-input
                    type="text"
                    name="ContactName"
                    label="Ansprechpartner der Firma (Vor- und Nachname)"
                    class="zas-main-col"
                    [entity]="state.hint"
                    property="ContactName"
                    [updateFn]="updateHint"
                ></zbd-input>
                <div class="zas-main-col">
                    <div class="zas-inner-table">
                        <zbd-input
                            type="date"
                            name="Birthdate"
                            label="Geburtsdatum"
                            class="zas-inner-col-left"
                            [entity]="state.hint"
                            property="Birthdate"
                            [updateFn]="updateHint"
                        ></zbd-input>
                        <div class="zas-inner-col-right"></div>
                    </div>
                </div>
            </div>

            <div class="zas-row">
                <zbd-input
                    type="select"
                    name="Occasion"
                    label="Beratungsanlass"
                    class="zas-main-col"
                    [entity]="state.hint"
                    property="Occasion"
                    [updateFn]="updateHint"
                >
                    <option value="">alle</option>
                    <option
                        *ngFor="let consultation of consultationOccasionList"
                        [value]="consultation.Data"
                    >
                        {{ consultation.Readable }}
                    </option>
                </zbd-input>
                <div class="zas-main-col">
                    <div class="zas-inner-table">
                        <zbd-input
                            type="date"
                            name="BeginCreationDate"
                            label="Erstellungsdatum von"
                            class="zas-inner-col-left"
                            [entity]="state.hint"
                            property="BeginCreationDate"
                            [updateFn]="updateHint"
                        ></zbd-input>
                        <zbd-input
                            type="date"
                            name="EndCreationDate"
                            label="bis"
                            class="zas-inner-col-right"
                            [entity]="state.hint"
                            property="EndCreationDate"
                            [updateFn]="updateHint"
                        ></zbd-input>
                    </div>
                </div>
            </div>

            <div class="zas-row">
                <div class="zas-main-col">
                    <zbd-input
                        type="radio"
                        name="Finalized"
                        label="Alle Stände anzeigen"
                        [entity]="state.hint"
                        property="Finalized"
                        [value]="null"
                        [updateFn]="updateHint"
                    ></zbd-input>
                    <zbd-input
                        type="radio"
                        name="Finalized"
                        label="Nur offene Stände anzeigen"
                        [entity]="state.hint"
                        property="Finalized"
                        [value]="false"
                        [updateFn]="updateHint"
                    ></zbd-input>
                    <zbd-input
                        type="radio"
                        name="Finalized"
                        label="Nur abgeschlossene Stände anzeigen"
                        [entity]="state.hint"
                        property="Finalized"
                        [value]="true"
                        [updateFn]="updateHint"
                    ></zbd-input>
                    <!--<input type="checkbox" id="onlyOpenProcesses" name="onlyOpenProcesses" class="form-control" formControlName="onlyOpenProcesses">
                <label for="onlyOpenProcesses">nur offene Stände anzeigen</label>
                <input type="checkbox" id="onlyClosedProcesses" name="onlyClosedProcesses" class="form-control" formControlName="onlyClosedProcesses">
                <label for="onlyClosedProcesses">nur finale Stände anzeigen</label>-->
                </div>
                <div class="zas-main-col">
                    <div class="zas-inner-table">
                        <zbd-input
                            type="date"
                            name="BeginFinalizationDate"
                            label="Abschlussdatum von"
                            class="zas-inner-col-left"
                            [entity]="state.hint"
                            property="BeginFinalizationDate"
                            [updateFn]="updateHint"
                        ></zbd-input>
                        <zbd-input
                            type="date"
                            name="EndFinalizationDate"
                            label="bis"
                            class="zas-inner-col-right"
                            [entity]="state.hint"
                            property="EndFinalizationDate"
                            [updateFn]="updateHint"
                        ></zbd-input>
                    </div>
                </div>
            </div>
        </div>

        <!-- Advanced search checkbox -->
        <div class="zas-row">
            <zbd-input
                type="checkbox"
                name="Extended"
                label="Erweiterte Suche"
                class="zas-main-col"
                [value]="state.extended"
                [updateFn]="setExtended"
            ></zbd-input>
            <div class="zas-main-col"></div>
        </div>

        <!-- Search form buttons -->
        <div class="zas-row">
            <button
                type="submit"
                [disabled]="searching"
                (click)="onSearchFormSubmit(state.hint)"
                class="zas-button-cta"
            >
                <span *ngIf="searching" class="icon-loop spinning"></span>
                <span *ngIf="!searching" class="icon-icon-cta"></span>
                <span class="button-label">Suche starten</span>
            </button>
            <span class="horizontal-spacer"></span>
            <!--<button type="button" class="zas-button">
            <span class="icon-i-cta-share"></span>
            <span class="button-label">Letzte Vorgänge</span>
            </button>-->
            <!--<span class="horizontal-spacer"></span>-->
            <button type="button" (click)="reset()" class="zas-button">
                <span class="icon-close-tag"></span>
                <span class="button-label">Zurücksetzen</span>
            </button>
            <span class="horizontal-spacer"></span>
            <button
                type="button"
                (click)="onNewProcessClick()"
                class="zas-button-cta"
                [disabled]="isCreatingProcess"
            >
                <span class="icon-plus"></span>
                <span class="button-label">Neuer Vorgang</span>
            </button>
            <span class="horizontal-spacer"></span>
        </div>

        <div class="zas-hr-blue-7"></div>
    </form>
</ng-container>
